export const getCloudflareCacheUrl = () => {
  const env = process.env.REACT_APP_TRBL_THREEKIT_ENV;

  if (env === "admin-fts") {
    return process.env.REACT_APP_ADMIN_FTS_CACHING_URL as string;
  }

  if (env === "preview") {
    return process.env.REACT_APP_PREVIEW_CACHING_URL as string;
  }

  return process.env.REACT_APP_PREVIEW_CACHING_URL as string;
};
